export default __webpack_public_path__ + "static/media/emoji-linkedin.b9c002d3.svg";